// extracted by mini-css-extract-plugin
export default {"chosenPatient":"Patient_chosenPatient__SWnIH"};